/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { forEach, isElement, keys, reverse, defer } from 'lodash';

import { store } from '../2-utilities/store';
import { subscribe, publish } from '../2-utilities/event';
import { isDesktop } from '../2-utilities/breakpoint';

import {
    YEAR_SELECTED as yearSelected,
    RESTART_AUTOPLAY as restartAutoplay,
    QUIT_AUTOPLAY as quitAutoplay,
    SHOW_INFO_BOX as showInfoBox,
    CHANGE_INFO_BOX as changeInfoBox,
    HIDE_INFO_BOX as hideInfoBox,
    MARKERS_PLACED as markersPlaced,
    OPEN_SIDEBAR
} from '../3-data/consts/eventNames';
import { styles } from '../3-data/consts/mapStyles';

import interpolateColors from '../4-features/interpolateColors';
import CustomMarker from '../4-features/CustomMarker';
import USGSOverlay from '../4-features/USGSOverlay';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'maps',
    baseSelector = `.js-${moduleName}`,
    selectors = {
        zoomIn: `${baseSelector}-zoom-in`,
        zoomOut: `${baseSelector}-zoom-out`
    },
    centerLatLng = new google.maps.LatLng(52.084166, 5.5124522),
    mapOptions = {
        // zoom: isDesktop() ? 8 : 7,           //initial zoom is now set by map.fitBounds()
        minZoom: isDesktop() ? 8 : 6.8,
        center: centerLatLng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: true,
        draggable: true,
        scaleControl: false,
        scrollwheel: true,
        styles: styles,
        backgroundColor: 'transparent'
    },
    { ranking } = store,
    yearList = ranking,
    swBound = new google.maps.LatLng(50.750938, 3.359403),
    neBound = new google.maps.LatLng(53.560406, 7.227496),
    bounds = new google.maps.LatLngBounds(swBound, neBound);

let map,
    markerWaitTime = 1000,
    years = keys(ranking),
    year = years[years.length - 1],
    timer,
    markers = [];

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function setCenter({ detail }) {
    map.setCenter(detail);
}

function addMarkers() {
    const list = reverse(yearList[year]),
        colors = interpolateColors(list.length, true);

    let i = 0;

    publish(showInfoBox);
    publish(quitAutoplay);

    function add() {
        const color = colors[i],
            item = list[i];

        publish(changeInfoBox, item);

        const mapItem = new CustomMarker(
            list,
            item,
            color,
            i,
            year
        );

        mapItem.setMap(map);

        markers.push(mapItem);

        i++;

        if (i < list.length) {
            timer = setTimeout(add, markerWaitTime / i);
        } else {
            // reset ranking list
            reverse(yearList[year]);

            setTimeout(() => {
                publish(markersPlaced);
                // publish(OPEN_SIDEBAR);
            }, 500);

            publish(hideInfoBox);
            publish(restartAutoplay);
        }
    };

    add();
}

document.addEventListener('click', () => markerWaitTime = 0);

function removeAllMarkers() {
    const markersDOM = document.querySelectorAll('.js-marker');

    forEach(markersDOM, marker => {
        marker.parentNode.removeChild(marker);
    })

    for (var i in markers) {
        markers[i].setMap(null);
    }

    markers = [];
}

function changeMarkers({ detail }) {
    const { selectedYear } = detail;

    if (yearList[year][0].Ranking > 1) {
        reverse(yearList[year]);
    }

    year = selectedYear;

    clearTimeout(timer);

    removeAllMarkers();
    addMarkers();
}

function zoomIn(event) {
    event.preventDefault();

    map.setZoom(map.getZoom() + 1);
}

function zoomOut(event) {
    event.preventDefault();

    map.setZoom(map.getZoom() - 1);
}

function zoomControls() {
    const zoomInElement = document.querySelector(selectors.zoomIn),
        zoomOutElement = document.querySelector(selectors.zoomOut);

    if (zoomInElement && zoomOutElement) {
        google.maps.event.addDomListener(zoomInElement, 'click', zoomIn);
        google.maps.event.addDomListener(zoomOutElement, 'click', zoomOut);
    }
}

function init(baseElement = document.querySelector(baseSelector)) {
    if (!isElement(baseElement)) {
        return false;
    }

    map = new google.maps.Map(baseElement, mapOptions);

    new USGSOverlay(bounds, map);

    map.fitBounds(bounds);

    addMarkers();
    zoomControls();

    window.map = map;
}

init();
subscribe(yearSelected, changeMarkers);
subscribe('mapSetCenter', setCenter);